const topicTags = [
  { name: '韩漫推荐', hot: '32.6万', active: true },
  { name: '日漫新番', hot: '28.1万', active: true },
  { name: '国漫崛起', hot: '25.4万', active: true },
  { name: '恋爱漫画', hot: '22.8万', active: false },
  { name: '玄幻修仙', hot: '20.3万', active: false },
  { name: '悬疑推理', hot: '18.7万', active: false },
  { name: '免费漫画', hot: '17.2万', active: false },
  { name: '画风精美', hot: '15.9万', active: false },
  { name: '穿越重生', hot: '14.5万', active: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            大家都在讨论什么
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[600px] mx-auto">
            热门话题标签，看看漫画圈的读者们都在关注哪些内容
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topicTags.map((item) => (
              <div
                key={item.name}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  item.active
                    ? 'bg-primary-500 border-primary-500 text-white'
                    : 'bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:bg-background-50'
                }`}
              >
                {item.active && (
                  <span className="text-[10px]">🔥</span>
                )}
                <span className="text-sm font-medium">{item.name}</span>
                <span className={`text-xs ${item.active ? 'text-white/70' : 'text-foreground-500'}`}>
                  {item.hot}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-10 p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-fire-line text-accent-500 text-lg"></i>
              <h3 className="text-sm font-bold text-foreground-900 font-heading">话题热榜说明</h3>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              以上话题标签根据近7日内漫画阅读量、收藏量、评论数及搜索热度综合生成。
              排名每日更新，反映蛙漫漫画平台读者群体真实的关注焦点与内容偏好。
              标记为激活态（橙色高亮）的话题为当前平台重点推荐内容方向，
              读者可通过话题标签快速定位感兴趣的漫画品类，发现更多优质作品。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}